export function formatPrice(price: number, currencyIsoCode?: string): string {
  return price.toLocaleString('en-US', {
    style: 'currency',
    currency: currencyIsoCode || 'USD',
  });
}
